const BASE_URL = process.env.REACT_APP_API_URL || "/api/";

// Função global para logout automático em caso de 403
let globalLogoutCallback = null;

export const setGlobalLogoutCallback = (callback) => {
  globalLogoutCallback = callback;
};

const handle403Error = () => {
  if (globalLogoutCallback) {
    globalLogoutCallback();
  }
};

export const API_CONFIG = {
  
  LOGIN_URL: `${BASE_URL}login`,
  
  LOGIN_ADMIN_URL: `${BASE_URL}login-admin`,
  
  CREATE_INDICATIONS_URL: `${BASE_URL}create-indication`,

  UPDATE_INDICATIONS_URL: `${BASE_URL}update-indication`,

  UPDATE_STATUS_INDICATIONS_URL: `${BASE_URL}update-status-indication`,

  DELETE_INDICATIONS_URL: `${BASE_URL}delete-indication`,

  GET_INDICATIONS_URL: `${BASE_URL}get-indications-user`,

  GET_ALL_USERS_URL: `${BASE_URL}get-all-users`,

  CREATE_USER_URL: `${BASE_URL}create-user`,

  UPDATE_USER_URL: `${BASE_URL}update-user`,
  
  // Timeout para requisições (em milissegundos)
  TIMEOUT: 10000,
  
  // Headers padrão para todas as requisições
  DEFAULT_HEADERS: {
    'Content-Type': 'application/json',
  }
};

// Função para obter headers com autenticação (se necessário)
export const getAuthHeaders = (token = null) => {
  const headers = { ...API_CONFIG.DEFAULT_HEADERS };
  
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  
  return headers;
};

// Função para fazer requisições com timeout
export const fetchWithTimeout = async (url, options = {}, timeout = API_CONFIG.TIMEOUT) => {
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), timeout);
  
  try {
    const response = await fetch(url, {
      ...options,
      signal: controller.signal,
    });
    clearTimeout(timeoutId);

    // Verificar se é erro 403 (Forbidden) - token inválido
    if (response.status === 403) {
      // Verificar se não é uma requisição de login (para evitar logout em tentativas de login)
      const isLoginRequest = url.includes('login') || url.includes('login-admin');
      
      if (!isLoginRequest) {
        console.warn('Token inválido detectado (403 Forbidden). Fazendo logout automático...');
        handle403Error();
      }
    }
    
    return response;
  } catch (error) {
    clearTimeout(timeoutId);
    throw error;
  }
};

// Função auxiliar para processar respostas da API de forma consistente
export const processApiResponse = async (response) => {
  const contentType = response.headers.get('content-type');
  
  let data;
  if (contentType && contentType.includes('application/json')) {
    data = await response.json();
  } else {
    throw new Error('Resposta do servidor não é JSON.');
  }

  // Verificar se a resposta indica sucesso
  if (!data.ok && data.status !== 200) {
    // Criar um erro personalizado com a mensagem da API
    const error = new Error(data.message || data.error || `Erro HTTP ${data.status || response.status}`);
    error.status = data.status || response.status;
    error.data = data;
    throw error;
  }

  return data;
};

